export * from './card'

export const AMEX_CVV_LENGTH = 4;
export const CARD_CVV_LENGTH = 3;
export const CVV_PLACEHOLDER_CHAR = '•';

export const CARD_TYPES = {
  VISA: 'VISA',
  MASTER_CARD: 'MASTERCARD',
  AMEX: 'AMEX',
  MAESTRO: 'MAESTRO',
  MEEZA: 'MEEZA',
  MADA: 'MADA',
  OMAN_NET: 'OMANNET',
  JCB: 'JCB',
};

export const paymentMethodsConstants = {
  CARD: 'card',
  CARDMOTO: 'card-moto',
  BANK_INSTALLMENT: 'card-installment',
  WALLET: 'wallet',
  E_WALLET: 'e-wallet',
  VALU: 'valu',
  APPLE_PAY: 'apple-pay',
  GOOGLE_PAY: 'google-pay',
  PAYPAL: 'paypal',
  PAY_LATR: 'pay later',
  SYMPL: 'sympl',
  KIOSK: 'kiosk',
  CASHCOLLECTION: 'cash-collection',
  PREMUIMCARD: 'premium-card',
  INSTAPAY: "instapay"
};

export const paymentMethodsTypes = {
  PREMIUM: 'premium',
  PREMIUM6: 'premium6',
  AMAN: 'aman',
  VALU: 'valu',
  AMANV3: 'aman_v3',
  CONTACT: 'contact',
  SOUHOOLA: 'souhoola',
  SOUHOOLAV3: 'souhoolav3',
  SYMPL: 'sympl',
  SYMPLV2: 'symplv2',
  FORSA: "forsa",
  TAMARA: "tamara",
  STC_PAY: "stcpay",
  TRU: 'tru',
  TABBY: "tabby",
  POST_PAY: "postpay",
  HALAN: "halan",
  EASYPAISA: "easypaisa",
  EASYPAISA_DIRECT: "easypaisadirect",
  MID_TAKSEET: 'mid-takseet',
  JAZZCASH: 'jazzcash',
  DIGITAL_WALLET: 'digital-wallet'
}